import add from 'date-fns/add';
import { zonedTimeToUtc } from 'date-fns-tz';

export function generateCookieExpire(expires: number, unit: keyof Duration = 'days') {
  return new Date(add(zonedTimeToUtc(new Date(), 'GMT'), { [unit]: expires }));
}
